import React from 'react';
import Button from 'shared/components/UC/Button';
import styles from './EvaluationScaleModal.module.css';

interface EvaluationScaleModalProps {
  onClose: () => void;
}

const scaleDescriptions = [
  {
    score: 1,
    label: 'Muy deficiente',
    description: 'Cumplimiento muy bajo de los criterios',
    details:
      'El proyecto presenta evidencia muy limitada y de baja calidad que apenas satisface el criterio.',
  },
  {
    score: 2,
    label: 'Insuficiente',
    description: 'Cumplimiento parcial e inadecuado',
    details:
      'El proyecto presenta evidencia parcial pero insuficiente para cumplir adecuadamente el criterio.',
  },
  {
    score: 3,
    label: 'Aceptable / Suficiente',
    description: 'Cumplimiento básico de los criterios',
    details:
      'El proyecto cumple los requisitos básicos del criterio de manera satisfactoria pero sin destacar.',
  },
  {
    score: 4,
    label: 'Bueno / Sólido',
    description: 'Cumplimiento sólido y bien fundamentado',
    details:
      'El proyecto demuestra un cumplimiento sólido del criterio con evidencia bien fundamentada y convincente.',
  },
  {
    score: 5,
    label: 'Excelente / Ejemplar',
    description: 'Cumplimiento excepcional y destacado',
    details:
      'El proyecto excede las expectativas del criterio de manera excepcional, representando un estándar ejemplar.',
  },
];

const EvaluationScaleModal: React.FC<EvaluationScaleModalProps> = ({
  onClose,
}) => {
  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <h2 className={styles.title}>Escala de Evaluación (1-5)</h2>
          <button className={styles.closeButton} onClick={onClose}>
            ✕
          </button>
        </div>

        <div className={styles.content}>
          <div className={styles.introduction}>
            <p>
              Utilice esta escala para asignar puntuaciones a cada criterio de
              evaluación. Las puntuaciones pueden incluir decimales (por
              ejemplo, 3.5, 4.2) para mayor precisión.
            </p>
          </div>

          <div className={styles.scaleList}>
            {scaleDescriptions.map((scale) => (
              <div key={scale.score} className={styles.scaleItem}>
                <div className={styles.scoreSection}>
                  <div className={styles.scoreCircle}>{scale.score}</div>
                  <div className={styles.scoreInfo}>
                    <h3 className={styles.scoreLabel}>{scale.label}</h3>
                    <p className={styles.scoreDescription}>
                      {scale.description}
                    </p>
                  </div>
                </div>
                <div className={styles.scoreDetails}>
                  <p>{scale.details}</p>
                </div>
              </div>
            ))}
          </div>

          <div className={styles.guidelines}>
            <h3 className={styles.guidelinesTitle}>Pautas de Puntuación</h3>
            <ul className={styles.guidelinesList}>
              <li>
                <strong>Consistencia:</strong> Mantenga criterios consistentes a
                lo largo de toda la evaluación.
              </li>
              <li>
                <strong>Evidencia:</strong> Base sus puntuaciones en evidencia
                específica de la propuesta.
              </li>
              <li>
                <strong>Precisión:</strong> Use puntuaciones decimales cuando
                sea apropiado para mayor precisión.
              </li>
              <li>
                <strong>Objetividad:</strong> Evalúe cada criterio de manera
                independiente y objetiva.
              </li>
              <li>
                <strong>Justificación:</strong> Proporcione comentarios
                detallados que justifiquen cada puntuación.
              </li>
            </ul>
          </div>
        </div>

        <div className={styles.footer}>
          <Button variant="primary" onClick={onClose} size="default">
            Entendido
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EvaluationScaleModal;
